import { FC } from 'react';
import Pipeline from '../app/Pipeline/Pipeline';
import StartPage from '../app/StartPage/StartPage';
import Algorithms from '../app/Algorithms/Algorithms';
import PipelineOverview from '../app/PipelineOverview/PipelineOverview';
import AlgorithmDocumentation from '../app/Algorithms/AlgorithmsTable/AlgorithmDocumentation';
import ResultsOverview from '../app/ResultsOverview/ResultsOverview';
import ResultsPipelineOverview from '../app/ResultsPipelineOverview/ResultsPipelineOverview';
import ServiceResult from '../app/ServiceResult/ServiceResult';
import Assignments from '../app/Assignments/Assignments';
import Assignment from '../app/Assignments/Assignment';
import AssignmentReview from '../app/Assignments/AssignmentReview';

type Route = {
  name: string;
  path: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: FC<any>;
};

// TODO: use internationalization
const routes: Route[] = [
  {
    name: 'Homepage',
    path: '/',
    Component: StartPage,
  },
  {
    name: 'Pipeline',
    path: '/pipeline/:pid',
    Component: Pipeline,
  },
  {
    name: 'Pipelines',
    path: '/pipelines',
    Component: PipelineOverview,
  },
  {
    name: 'Algorithmen',
    path: '/algorithm',
    Component: Algorithms,
  },
  {
    name: 'Ergebnisse',
    path: '/results',
    Component: ResultsOverview,
  },
  {
    name: 'Ergebnisse',
    path: '/results/:rid',
    Component: ResultsPipelineOverview,
  },
  {
    name: 'Ergenisse',
    path: '/results/:rid/:sid',
    Component: ServiceResult,
  },
  {
    name: 'AlgorithmenDokumentation',
    path: '/algorithm/:serviceName',
    Component: AlgorithmDocumentation,
  },
  {
    name: 'Aufgaben',
    path: '/assignments',
    Component: Assignments,
  },
  {
    name: 'Aufgaben',
    path: '/assignments/:assignment_title',
    Component: Assignment,
  },
  {
    name: 'AufgabenReview',
    path: '/assignments/:assignment_title/review',
    Component: AssignmentReview,
  }
];

export default routes;
